import React from "react";

export const Arrow = ({ color }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#arrow-clippath1)">
      <path
        d="M3.04883 8L12.9488 8"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.89941 12.0498L12.9494 7.9998L8.89941 3.94981"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="arrow-clippath1">
        <rect
          width="14.4"
          height="14.4"
          fill="white"
          transform="translate(0.799805 15.2002) rotate(-90)"
        />
      </clipPath>
    </defs>
  </svg>
);
